/**
 * PreviewBanner — shown when the current session is an admin portal preview.
 * Reads the ml_preview_mode flag from sessionStorage (set by
 * PortalPreviewAuthPage). sessionStorage is tab-scoped (#2151): the preview
 * identity must be invisible to the admin's ORIGINAL tab, which renders this
 * same SidebarLayout — a localStorage flag showed the banner in BOTH tabs.
 * Displayed above BillingBanner in SidebarLayout.
 */

export function PreviewBanner() {
  const isPreview = sessionStorage.getItem('ml_preview_mode') === '1'
  if (!isPreview) return null

  const previewName = sessionStorage.getItem('ml_preview_name')

  return (
    <div
      style={{
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '8px 16px',
        background: 'var(--st-info)',
        borderBottom: '1px solid color-mix(in srgb, var(--st-info) 70%, transparent)',
        color: 'var(--brand-gold-text)',
        fontSize: '13px',
        fontFamily: 'var(--font-sans, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif)',
        gap: '12px',
      }}
    >
      <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {previewName ? (
          <>
            <strong style={{ fontWeight: 700 }}>Previewing as {previewName}</strong>
            {' — '}Write actions are disabled.
          </>
        ) : (
          <>
            <strong style={{ fontWeight: 700 }}>Admin Preview</strong>
            {' — '}You are viewing the platform as a Client. Write actions are disabled.
          </>
        )}
      </span>
      <button
        onClick={() => {
          // Clear only this tab's sessionStorage preview identity (#2151) —
          // never localStorage, which holds the admin's real session.
          sessionStorage.removeItem('ml_preview_mode')
          sessionStorage.removeItem('ml_preview_token')
          sessionStorage.removeItem('ml_token')
          sessionStorage.removeItem('ml_token_exp')
          sessionStorage.removeItem('ml_user')
          sessionStorage.removeItem('ml_preview_name')
          window.close()
        }}
        style={{
          background: 'none',
          border: '1px solid rgba(255,255,255,0.4)',
          borderRadius: '6px',
          color: 'inherit',
          padding: '3px 10px',
          fontSize: '12px',
          cursor: 'pointer',
          flexShrink: 0,
          fontFamily: 'inherit',
        }}
      >
        Exit preview
      </button>
    </div>
  )
}
